import { Container, Card } from 'react-bootstrap';

export default function TermsOfService() {
  return (
    <div className="bg-light min-vh-100 py-5">
      <Container>
        <Card className="shadow-sm">
          <Card.Body className="p-4 p-md-5">
            <h1 className="h3 fw-bold mb-3">Terms of Service</h1>
            <p className="text-muted mb-4">
              These Terms of Service (“Terms”) constitute a legally binding
              agreement between
              <strong> SupplyPassport OÜ</strong>, a company registered in
              Estonia, and the entity or individual (“User,” “you,” or “your”)
              accessing the SupplyPassport platform via
              <strong> SupplyPassport.app</strong> and related services.
            </p>

            <h2 className="h5 fw-semibold mt-4">1. Acceptance of Terms</h2>
            <p>
              By creating an account, accessing, or using the services, you
              acknowledge that you have read, understood, and agree to be bound
              by these Terms. If you are entering into these Terms on behalf of
              a legal entity, you represent that you have the authority to bind
              such entity to these conditions.
            </p>

            <h2 className="h5 fw-semibold mt-4">
              2. Scope of Service and Eligibility
            </h2>
            <p>
              SupplyPassport provides a Software-as-a-Service (SaaS) platform
              for supplier risk and compliance management. You must be at least
              18 years of age and possess the legal capacity to enter into
              binding contracts to use this Service.
            </p>

            <h2 className="h5 fw-semibold mt-4">
              3. User Accounts and Security
            </h2>
            <p>
              You agree to provide accurate and complete information during
              registration. You are solely responsible for safeguarding your
              account credentials. You must notify SupplyPassport OÜ immediately
              of any unauthorized use or security breach.
            </p>

            <h2 className="h5 fw-semibold mt-4">
              4. Intellectual Property and Data
            </h2>
            <p>
              SupplyPassport OÜ retains all rights, title, and interest in the
              Service. You retain ownership of any content you submit (“User
              Data”), but grant us a worldwide, royalty-free license to host,
              process, and display it as necessary to provide the Service. All
              personal data is processed in accordance with the GDPR and our
              Privacy Policy.
            </p>

            <h2 className="h5 fw-semibold mt-4">
              5. Modifications and Availability
            </h2>
            <p>
              We reserve the right to modify, suspend, or discontinue features
              of the Service at our discretion. We may update these Terms
              periodically. Continued use of the Service after changes become
              effective constitutes your acceptance of the updated Terms.
            </p>

            <h2 className="h5 fw-semibold mt-4">6. Disclaimers</h2>
            <p>
              The Service is provided on an "as is" and "as available" basis. To
              the maximum extent permitted by Estonian law, SupplyPassport OÜ
              disclaims all warranties, including implied warranties of
              merchantability, fitness for a particular purpose, and
              non-infringement.
            </p>

            <h2 className="h5 fw-semibold mt-4">7. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, SupplyPassport OÜ will not
              be liable for indirect, incidental, or consequential damages. Our
              total liability for any claim shall not exceed the amount paid by
              you to the Company in the twelve (12) months preceding the event
              giving rise to the claim.
            </p>

            <h2 className="h5 fw-semibold mt-4">8. Termination</h2>
            <p>
              We may terminate or suspend your access to the Service
              immediately, without prior notice, if you violate these Terms or
              engage in prohibited conduct. Upon termination, your right to use
              the Service ceases immediately.
            </p>

            <h2 className="h5 fw-semibold mt-4">
              9. Governing Law and Jurisdiction
            </h2>
            <p>
              These Terms are governed by the laws of <strong>Estonia</strong>.
              Any disputes arising out of these Terms shall be subject to the
              exclusive jurisdiction of the courts in{' '}
              <strong>Tallinn, Estonia</strong>.
            </p>

            <h2 className="h5 fw-semibold mt-4">10. Contact</h2>
            <p className="mb-0">
              If you have questions about these Terms, please contact your
              account representative or support at{' '}
              <strong>info@supplypassport.co</strong>.
            </p>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}
